import axios from "axios";

const API = process.env.REACT_APP_API; // Change this to your backend URL if different


export const fetchLeaderboard = async (projectId, sprintId) => {
  const res = await axios.get(`${API}/api/leaderboard`, {
    params: { project_id: projectId, sprint_id: sprintId }
  });
  return res.data;
};
